import su from './sub.module.scss';

export default function SubmitBtn3({ label, disabled }) {
  return (
    <>
      <input type="submit" className={su.in} disabled={disabled} value={label} />
    </>
  );
}


export  function SubmitBtn4({ label, disabled, onClick }) {
  return (
    <>
      <input type="button" onClick={onClick} className={su.in} disabled={disabled} value={label} />
    </>
  );
}
